import { createStore } from "vuex";
//import authModule from "./auth/index";
//import settingsModule from "./settings/index";
import onboardingModule from "./onboarding/index";

export default createStore({
  state() {
    return {
      isLoading: false,
    };
  },
  mutations: {
    setIsLoading(state, payload) {
      state.isLoading = payload;
    },
  },
  actions: {
    setIsLoading(context, payload) {
      context.commit("setIsLoading", payload);
    },
  },
  modules: {
    //authModule,
    //settingsModule,
    onboardingModule,
  },
  getters: {
    getIsLoading(state) {
      return state.isLoading;
    },
  },
});
